// extracted by mini-css-extract-plugin
export default {"likeButton":"rS-z","unLikedButton":"sS-z","likedButton":"tS-z"};